export const metadata = {
  siteURL: 'https://www.dish.com/availability',
  siteName: 'Dish',
  alternateName: 'dish.com',
}
